import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createRunSnowflakeRefiScoreThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.RunSnowflakeRefiScoreCheck,
    async () => {
      const response = await api.runSnowflakeRefiScoreCheck();

      return response;
    },
  );
